// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#assistant-stawag-waerme-plus-gjuce .theme--light.v-subheader{color:rgba(0,0,0,.6)}#assistant-stawag-waerme-plus-gjuce .theme--dark.v-subheader{color:hsla(0,0%,100%,.7)}#assistant-stawag-waerme-plus-gjuce .v-subheader{align-items:center;display:flex;height:48px;font-size:.875rem;font-weight:400;padding:0 16px 0 16px}#assistant-stawag-waerme-plus-gjuce .v-subheader--inset{margin-left:56px}", ""]);
// Exports
module.exports = exports;
